package com.fireavert.tenants.data_models

import kotlinx.serialization.Serializable

@Serializable
data class TenantModel(
    val id: Int? = null,
    val firstName: String,
    val lastName: String,
    val email: String,
    val phoneOneNumber: String? = null,
    val phoneOneNumberLocation: String? = null,
    val phoneTwoNumber: String? = null,
    val phoneTwoNumberLocation: String? = null,
    val status: TenantStatus,
    val unitId: Int,
    val yardiUnitId: String? = null,
    val textsUnlocked: Boolean = false,
    val emailUnlocked: Boolean = false,
    val hasPet: Boolean = false,
)
